/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
	const { nodes, materials } = useGLTF("models/polysterWool.glb");
	return (
		<group {...props} dispose={null}>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder010.geometry}
				material={materials["Fabric 63"]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder010_1.geometry}
				material={materials.Glass}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder010_2.geometry}
				material={materials["Material.001"]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder010_3.geometry}
				material={materials.Fur}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder010_4.geometry}
				material={materials["Material.002"]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder010_5.geometry}
				material={materials["Hemp fabric"]}
			/>
		</group>
	);
}

useGLTF.preload("models/polysterWool.glb");
